module.exports = __webpack_public_path__ + "img/responsive crc-03.f1010007.jpg";